import React from 'react';
import { ShieldAlert } from 'lucide-react';

/**
 * Aviso de supressão estatística (LGPD).
 *
 * Exibido quando um recorte segmentado (setor, tempo de empresa) reúne menos
 * respondentes do que o mínimo necessário para preservar o anonimato. O total
 * agregado da empresa nunca é suprimido — apenas os recortes internos.
 */
export const SuppressionNotice = ({ totalSessions, minRespondents = 5, isDarkMode }) => (
  <div
    className={`rounded-lg border p-8 text-center ${
      isDarkMode ? 'bg-zinc-900 border-amber-900/40' : 'bg-white border-amber-300'
    }`}
    data-testid="suppression-notice"
  >
    <ShieldAlert size={40} className="mx-auto mb-4 text-amber-500" />
    <h3 className={`text-lg font-semibold mb-2 ${isDarkMode ? 'text-zinc-200' : 'text-zinc-800'}`}>
      Recorte suprimido para preservar o anonimato
    </h3>
    <p className={`text-sm max-w-xl mx-auto leading-relaxed ${isDarkMode ? 'text-zinc-400' : 'text-zinc-600'}`}>
      O filtro aplicado retornou{' '}
      <strong className={isDarkMode ? 'text-zinc-200' : 'text-zinc-800'}>
        {totalSessions} {totalSessions === 1 ? 'respondente' : 'respondentes'}
      </strong>
      , abaixo do mínimo de <strong>{minRespondents}</strong> exigido para exibição de resultados
      segmentados. Em conformidade com a LGPD e com o compromisso de anonimato assumido na coleta,
      recortes com n &lt; {minRespondents} não são exibidos, pois permitiriam a reidentificação
      individual dos respondentes.
    </p>
    <p className={`text-xs mt-4 ${isDarkMode ? 'text-zinc-500' : 'text-zinc-500'}`}>
      Amplie o recorte — selecione mais setores ou remova filtros — para visualizar os resultados.
      O resultado agregado da empresa não sofre supressão.
    </p>
  </div>
);
